<template>
  <div
    class="flex flex-col h-3/6 bg-light-grey rounded-xl p-5 overflow-hidden shadow-lg border border-gray-100"
  >
    <!-- Header with better typography -->
    <div class="mb-4">
      <h3 class="text-primary-900 font-semibold text-lg flex items-center gap-2">
        <v-icon class="text-primary-600">mdi-history</v-icon>
        {{ $t("calls.calls_logs") }}
      </h3>
      <p class="text-primary-600 text-sm mt-1">
        <span v-if="currentCall?.SourceID">
          Previous call reasons for {{ currentCall.SourceID }}
        </span>
        <span v-else>
          Previous call reasons for this number
        </span>
      </p>
    </div>

    <!-- Content area - conditionally render scrollable list or empty state -->
    <div class="flex-1 flex flex-col min-h-0">
      <!-- Scrollable reasons list -->
      <div
        v-if="lastReasons.length > 0"
        ref="transcriptContainer"
        class="flex-1 overflow-y-auto pr-1 custom-scrollbar"
      >
        <div class="space-y-3 pr-2 pb-2">
          <div
            v-for="item in lastReasons"
            :key="item.id"
            class="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md hover:border-primary-200 transition-all duration-200 cursor-pointer group"
          >
            <!-- Header with time and user -->
            <div class="flex items-center justify-between mb-3">
              <div class="flex items-center gap-2 text-primary-500">
                <v-icon size="16" class="text-primary-400">mdi-clock-outline</v-icon>
                <span class="text-xs font-medium">{{ formatTime(item.time) }}</span>
              </div>
              <div class="flex items-center gap-2 text-primary-600">
                <v-icon size="16" class="text-primary-400">mdi-account-circle-outline</v-icon>
                <span class="text-xs font-medium">{{ item.userid }}</span>
              </div>
            </div>
            
            <!-- Main reason content -->
            <div class="border-l-4 border-primary-300 pl-3 bg-primary-50/30 py-2 rounded-r">
              <p class="text-primary-900 text-sm font-medium leading-relaxed group-hover:text-primary-700 transition-colors">
                {{ item.reason }}
              </p>
            </div>
            
            <!-- Bottom accent line -->
            <div class="mt-3 h-0.5 bg-gradient-to-r from-primary-200 to-transparent opacity-60"></div>
          </div>
        </div>
      </div>

      <!-- Enhanced empty state - only when no reasons -->
      <div
        v-else
        class="flex-1 flex flex-col items-center justify-center gap-4 text-center"
      >
        <div class="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
          <v-icon size="32" class="text-primary-400">mdi-phone-log</v-icon>
        </div>
        <div>
          <p class="text-primary-900 font-medium mb-1">
            {{ $t("calls.reasons.no_previous_calls") }}
          </p>
          <p class="text-primary-500 text-sm">
            {{ $t("calls.reasons.no_calls_description") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      lastReasons: [],
      lastReasonsInterval: null,
    };
  },
  methods: {
    ...mapActions(["GetCallerLastReasons", "SetMessageDialog"]),
    async getLastReasons() {
      try {
        var resp = await this.GetCallerLastReasons(this.currentCall.SourceID);
        if (resp.success) {
          // this.SetMessageDialog({ show: true, message: resp.message });
          // } else {
          this.lastReasons = resp.lastReasons;
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initLastReasons() {
      // console.log("My initLast Reasons:", this.currentCall);
      if (
        this.currentCall &&
        this.currentCall?.SourceID &&
        this.currentCall?.SourceID != ""
      ) {
        await this.getLastReasons();
      }
      // if (!this.currentCall.CallerID.includes("1234567")) {
      //   this.lastReasons = [];
      // }
      // await this.getLastReasons();
      // this.lastReasonsInterval = setInterval(() => {
      //   this.getLastReasons();
      // }, 15000);
      // this.$store.commit("setLastReasonInterval", this.lastReasonsInterval);
    },
    formatTime(time) {
      try {
        const date = new Date(time);
        return date.toLocaleString(undefined, {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return time; // Fallback to original time if parsing fails
      }
    }
  },
  computed: {
    ...mapGetters(["currentCall"]),
  },
  watch: {
    async currentCall(newValue) {
      // console.log("My lastcallreasons call",newValue )
      if (newValue) {
        await this.initLastReasons();
      }
    },
  },
  async mounted() {
    // console.log("My this call", this.call)
    if (this.currentCall) {
      await this.initLastReasons();
    }
  },
  beforeUnmount() {
    if (this.lastReasonsInterval) {
      clearInterval(this.lastReasonsInterval);
      this.lastReasonsInterval = null;
    }
  },
};
</script>
<style scoped>
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #d1d5db #f9fafb;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f9fafb;
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
</style>
